import React from 'react';
import Header from '../../Components/Header';


const HotelDetail = () => (
  <>
  <Header></Header>
   <section className='Visa_top_banner'>
     
    </section>
  </>
   
);

export default HotelDetail;
